import { STATES } from '../../constants/constants';
import { useAuth } from '../../context/AuthContext';
import { formatAddress } from '../../utils/formatters';

const CustomerInfoPanel = ({ customerFirstName, customerLastName, serviceAddress, serviceCity, serviceState, serviceZip, county }) => {

  const { isAdmin } = useAuth();

  const serviceAddressFormatted = formatAddress({
    street: serviceAddress,
    city: serviceCity,
    state: serviceState,
    zip: serviceZip,
  });

  return (
      <div className="text-muted">
        <strong>Customer Information</strong>
        <hr/>
        <strong>{customerFirstName} {customerLastName}</strong>
        <br />
        {serviceAddressFormatted || 'N/A'}
        {serviceState === STATES.WA && county && (
          <>
            <br />
            County: {county}
          </>
        )}
    </div>
  );
};

export default CustomerInfoPanel;
